import Typography from "@mui/material/Typography";
import { PricebookPeriod } from "../../../../types/price-book.type";
import {
  formatDaysLeft,
  formatPeriodRange,
  hasPeriodStarted,
  isPeriodEnded,
} from "./periodModel";

interface PeriodRangeTextProps {
  period: Pick<PricebookPeriod, "start_date" | "end_date" | "status" | "ends_in_days">;
}

/** Both days of a period and, while it runs, how long it has left. */
export default function PeriodRangeText({ period }: PeriodRangeTextProps) {
  const isRunning = hasPeriodStarted(period.status) && !isPeriodEnded(period.status);

  return (
    <>
      <Typography variant="body2" noWrap>
        {formatPeriodRange(period.start_date, period.end_date)}
      </Typography>
      {isRunning && (
        <Typography variant="caption" color="text.secondary">
          {formatDaysLeft(period.ends_in_days)}
        </Typography>
      )}
    </>
  );
}
